import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const dataDelimiter = ';;;';

export const usePriceLegalInfoPopup = () => {
  const {cancel, isOpen, open, parameter} =
    useOpenedStateManager('PRICE-LEGAL-INFO');
  const [title, body] = (parameter || '').split(dataDelimiter);

  const handleOpen = ({title, body}: {title: string; body: string}) => {
    open({
      parameter: `${title}${dataDelimiter}${body}`,
    });
  };

  return {
    priceLegalInfoPopupContent: {
      title,
      body,
    },
    cancel,
    isOpen,
    open: handleOpen,
  };
};
